module.exports = __webpack_public_path__ + "static/Union-821468960ed113fb4abb653ea8aaa608.svg";